import { render, staticRenderFns } from "./SexPicker.vue?vue&type=template&id=1aea2d73&lang=pug&"
import script from "./SexPicker.vue?vue&type=script&lang=js&"
export * from "./SexPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports